import m from "../../../../geodata/es2015/region/world/latinAmericaLow";
window.am4geodata_region_world_latinAmericaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/latinAmericaLow.js
// module id = null
// module chunks = 